// extracted by css-extract-rspack-plugin
export default {"cls1":"TypeWriter-cls1_6tK","cls2":"TypeWriter-cls2_jsT TypeWriter-cls1_6tK"};